import LocaleLink from '@/components/LocaleLink';
import { useLocale } from '@/hooks/useLocale';
import { ABOUT_EN } from '@/copy/about-en';
import { ABOUT_AR } from '@/copy/about-ar';
import './AboutPage.css';

/* About Prinotes — lean disclosure page (KSA E-Commerce Law surface). */
export default function AboutPage() {
  const { locale, dir } = useLocale();
  const doc = locale === 'ar' ? ABOUT_AR : ABOUT_EN;

  return (
    <div className="abt-page" dir={dir}>
      <header className="abt-hero">
        <div className="mkt-container abt-hero__inner">
          <p className="mkt-eyebrow" style={{ margin: 0 }}>
            {doc.eyebrow}
          </p>
          <h1 className="abt-hero__title">{doc.title}</h1>
        </div>
      </header>

      <div className="mkt-container">
        <div className="abt-body">
          {doc.intro.map((p, i) => (
            <p key={i} className="abt-p">
              {p}
            </p>
          ))}

          <section className="abt-card" aria-labelledby="abt-details-h">
            <h2 id="abt-details-h" className="abt-card__title">
              {doc.detailsHeading}
            </h2>
            <dl className="abt-dl">
              {doc.details.map((d) => (
                <div key={d.label} className="abt-dl__row">
                  <dt className="abt-dl__key">{d.label}</dt>
                  <dd className="abt-dl__val">{d.value}</dd>
                </div>
              ))}
            </dl>
          </section>

          <section className="abt-card" aria-labelledby="abt-contact-h">
            <h2 id="abt-contact-h" className="abt-card__title">
              {doc.contactHeading}
            </h2>
            <p className="abt-p">{doc.contactIntro}</p>
            <dl className="abt-dl">
              {doc.contacts.map((c) => (
                <div key={c.email} className="abt-dl__row">
                  <dt className="abt-dl__key">{c.label}</dt>
                  <dd className="abt-dl__val">
                    <a className="abt-link" href={`mailto:${c.email}`} dir="ltr">
                      {c.email}
                    </a>
                  </dd>
                </div>
              ))}
            </dl>
          </section>

          <p className="abt-p abt-privacy">
            {doc.privacyBefore}
            <LocaleLink to="/privacy" className="abt-link">
              {doc.privacyLinkLabel}
            </LocaleLink>
            {doc.privacyAfter}
          </p>
        </div>
      </div>
    </div>
  );
}
